import { Checkbox, FormControlLabel, FormGroup, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SetAnswersValue } from "../../../../../redux/slice/SurveySlice/AnswerSlice";
import CheckboxesAnswer from "./CheckboxesAnswer";

export default function Checkboxes({
  options,
  questionsindex,
  answers,
  AnswersFontScales
}) {
  const [checkboxes, setcheckboxes] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    var checkBoxArray = options.map((_) => false);
    setcheckboxes([...checkBoxArray]);
  }, []);

  function onChangeAnswer(index, value) {
    var copyarray = checkboxes;
    copyarray[index] = value;
    setcheckboxes(copyarray);
    dispatch(
      SetAnswersValue({ index: questionsindex, value: [...checkboxes] })
    );
  }

  if (answers !== undefined) {
    return (
      <>
        <CheckboxesAnswer options={options} answers={answers} />
      </>
    );
  } else {
    return (
      <>
        {!!options ? (
          <>
            {options.map((answer, index) => (
              <FormGroup key={index}>
                <FormControlLabel
                  value={checkboxes[index]}
                  onChange={(e) => onChangeAnswer(index, e.target.checked)}
                  className="flex items-start w-full ml-2 md:py-4 py-2 pl-5 m-2 space-x-2 border-2 cursor-pointer bg-black/5 border-black/10 rounded-xl overflow-hidden break-words"
                  control={
                    <Checkbox
                      sx={{
                        '& .MuiSvgIcon-root': { fontSize: AnswersFontScales },
                      }}
                      value={checkboxes[index]}
                    />
                  }
                  label={
                    <Box
                      component="div"
                      fontSize={AnswersFontScales}
                      sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        width: '100%',
                        display: 'block',
                      }}
                      className="text-left break-words w-full"
                    >
                      {answer}
                    </Box>

                  }
                />
              </FormGroup>
            ))}
          </>
        ) : (
          ""
        )}
      </>
    );
  }
}
